import { defineStore } from "pinia";

export enum NavBarStyle {
	SIDE_BAR,
	TOP_BAR,
}

export const useNavBarStore = defineStore("nav-bar", () => {
	const style = useLocalStorage<NavBarStyle>("nav-bar", NavBarStyle.SIDE_BAR);

	const isSideBar = computed(() => style.value === NavBarStyle.SIDE_BAR);

	return { style, isSideBar };
});
